import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import CoreuiVue from '@coreui/vue'
import router from './router'
import store from './store'
import { freeSet as icons } from '@coreui/icons'
import Multiselect from 'vue-multiselect'
import VueMask from 'v-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask'
import 'sweetalert2/dist/sweetalert2.min.css';
import Meta from 'vue-meta';

Vue.use(Meta);
Vue.use(VueSweetalert2);
Vue.use(VueMask);
Vue.use(VueTheMask);
Vue.use(CoreuiVue);
Vue.component('multiselect', Multiselect);

Vue.config.productionTip = false
new Vue({
  router,
  store,
  icons,
  render: h => h(App)
}).$mount('#app')
